import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonEn from "./locales/en/common.json";
import authEn from "./locales/en/auth.json";
import settingsEn from "./locales/en/settings.json";
import adminUsersEn from "./locales/en/admin-users.json";
import adminSettingsEn from "./locales/en/admin-settings.json";
import adminAgentsEn from "./locales/en/admin-agents.json";
import adminPlaybooksEn from "./locales/en/admin-playbooks.json";
import adminStrategiesEn from "./locales/en/admin-strategies.json";
import worldEn from "./locales/en/world.json";

void i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  ns: [
    "common",
    "auth",
    "settings",
    "admin-users",
    "admin-settings",
    "admin-agents",
    "admin-playbooks",
    "admin-strategies",
    "world",
  ],
  resources: {
    en: {
      common: commonEn,
      auth: authEn,
      settings: settingsEn,
      "admin-users": adminUsersEn,
      "admin-settings": adminSettingsEn,
      "admin-agents": adminAgentsEn,
      "admin-playbooks": adminPlaybooksEn,
      "admin-strategies": adminStrategiesEn,
      world: worldEn,
    },
  },
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
